import Vue from 'vue';
import { Cookies } from 'quasar';

export function post ({ state, getters, dispatch }, argRequest) {
  if (!getters.isLoggedIn) dispatch('logout');
  let myRequest = clone(argRequest);
  myRequest.filter.userMail = state.user.mail;
  myRequest.filter.aplicacion = 0;
  myRequest.filter.paginate = myRequest.paginate;

  return new Promise((resolve, reject) => {
    Vue.axios({
      url: myRequest.controller,
      data: myRequest.filter,
      method: 'POST'
    })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        var errorMessage = 'Error desconocido';

        switch (err.message) {
          case 'Network Error':
            errorMessage = 'Error de red';
            break;
          case 'Request failed with status code 400':
            errorMessage = 'Error en la petición';
            break;
          case 'Request failed with status code 401':
            errorMessage =
              'Error de autenticación, por favor vuelva a iniciar sesión';
            break;
        }
        reject(errorMessage);
        if (getters.isDebugMode) console.error(err);
      });
  });
}

export function getDataUser ({ state, commit, getters, dispatch }) {
  if (!getters.isLoggedIn) dispatch('logout');
  let myRequest = { filter: {} };
  myRequest.filter.userMail = getters.userMail;
  myRequest.filter.appId = process.env.VUE_APP_ID;
  dispatch('putAxiosHeader');
  return new Promise((resolve, reject) => {
    Vue.axios({
      url: process.env.VUE_APP_API_URL + '/UserAppInfo',
      params: dotNotate(myRequest.filter),
      method: 'GET'
    })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        var errorMessage = 'Error al obtener los permisos';
        switch (err.message) {
          case 'Network Error':
            errorMessage = 'Error de red';
            break;
          case 'Request failed with status code 400':
            errorMessage = 'Error en la petición';
            break;
          case 'Request failed with status code 401':
            errorMessage =
              'Error de autenticación, por favor vuelva a iniciar sesión';
            break;
        }
        reject(errorMessage);
        if (getters.isDebugMode) console.error(err);
        dispatch('logout').then(() => {});
      });
  });
}

export function loadUserRoles ({ state, commit, getters, dispatch }) {
  if (!getters.isLoggedIn) dispatch('logout');
  let myRequest = { filter: {} };
  myRequest.filter.userMail = getters.userMail;
  // myRequest.filter.aplicacion = getters.externalAppId;
  myRequest.filter.appId = process.env.VUE_APP_ID;
  dispatch('putAxiosHeader');
  return new Promise((resolve, reject) => {
    Vue.axios({
      url: process.env.VUE_APP_API_URL + '/UserAppInfo/Get',
      params: dotNotate(myRequest.filter),

      method: 'GET'
    })
      .then(resp => {
        let user = state.user;
        user.apps = user.apps || {};
        user.apps.tsz = {
          portfolio: [],
          showTree: true,
          rolAplicacion: resp.data.appInfo.applicationRol
        };
        let portfolio = [];
        let portfolioRaw = resp.data.portFolio;
        portfolioRaw.forEach(function (customer) {
          portfolio.push({
            label: customer.name,
            value: customer.id
          });
        });
        user.apps.tsz.portfolio = portfolio;
        commit('setUser', user);
      })
      .catch(err => {
        var errorMessage = 'Error al obtener los permisos';
        switch (err.message) {
          case 'Network Error':
            errorMessage = 'Error de red';
            break;
          case 'Request failed with status code 400':
            errorMessage = 'Error en la petición';
            break;
          case 'Request failed with status code 401':
            errorMessage =
              'Error de autenticación, por favor vuelva a iniciar sesión';
            break;
        }
        reject(errorMessage);
        if (getters.isDebugMode) console.error(err);
        dispatch('logout').then(() => {});
      });
  });
}

export function logout ({ commit }) {
  return new Promise((resolve, reject) => {
    commit('logout');
    Cookies.remove('_id');
    localStorage.removeItem('vuex');
    Vue.axios.defaults.headers.common['Authorization'] = '';
    resolve();
  });
}

export function putAxiosHeader ({ getters }) {
  Vue.axios.defaults.headers.common['Authorization'] = getters.tokenSuez;
}

export function clone (original) {
  return JSON.parse(JSON.stringify(original));
}

export function dotNotate (obj, parent = [], keyValue = {}) {
  for (let key in obj) {
    let keyPath = [...parent, key];
    if (obj[key] !== null && typeof obj[key] === 'object') {
      Object.assign(keyValue, dotNotate(obj[key], keyPath, keyValue));
    } else {
      keyValue[keyPath.join('.')] = obj[key];
    }
  }
  return keyValue;
}

export function postDatosValidarUsuario ({ state, commit, getters, dispatch }) {
  let data = JSON.stringify({
    user: {
      user: {
        mail: state.Usuario.user.mail,
        isExternal: state.Usuario.user.isExternal,
        appName: state.Usuario.user.appName,
        password: state.Usuario.user.password,
        id: state.Usuario.user.id
      },
      profile: {
        nombre: state.Usuario.profile.nombre,
        apellidos: state.Usuario.profile.apellidos,
        empresa: state.Usuario.profile.empresa,
        telefono: state.Usuario.profile.telefono,
        id: state.Usuario.profile.id
      },
      AceptaGdpr: state.Usuario.AceptaGdpr,
      AvisosComerciales: state.Usuario.AvisoComercial,
      id: state.Usuario.id
    }
  });

  return new Promise((resolve, reject) => {
    Vue.axios({
      url: process.env.VUE_APP_API_URL + '/AnonymousUser',
      data: data,
      headers: { 'content-type': 'application/json' },
      method: 'POST'
    })
      .then(resp => {
        resolve(resp);
        // console.log('API_DATA_ValidarUsuario___: OK ' );
      })
      .catch(err => {
        var errorMessage = '';
        // console.log('API_DATA_ValidarUsuario___: ERROR:' + err.response.data);
        switch (err.response.data) {
          case 'Usuario no encontrado en LDAP':
            errorMessage = 'Este correo no es un correo de Suez válido';
            break;
          case 'Usuario ya registrado':
            errorMessage = 'Este usuario ya ha sido registrado';
            break;
          case 'Token expiró':
            errorMessage =
              'El código asignado para validarse ya expiró y debe registrarse de nuevo';
            break;
          case 'Request failed with status code 400':
            errorMessage = 'Error en la petición';
            break;
          case 'Request failed with status code 401':
            errorMessage =
              'Error de autenticación, por favor vuelva a iniciar sesión';
          case 'Error validando request':
            errorMessage = 'Se ha producido un error ';
            break;
        }
        err.response.data = errorMessage;
        reject(err);
        if (getters.isDebugMode) console.error(err);
      });
  });
}

export function postDatosRegistrarUsuario ({
  state,
  commit,
  getters,
  dispatch
}) {
  let data = JSON.stringify({
    data: {
      mail: state.UsuarioRegistro.mail,
      token: state.UsuarioRegistro.token
    }
  });

  return new Promise((resolve, reject) => {
    Vue.axios({
      url: process.env.VUE_APP_API_URL + '/AnonymousUser/Validate',
      data: data,
      headers: { 'content-type': 'application/json' },
      method: 'POST'
    })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        var errorMessage = 'Error desconocido';
        if (err.response.data.contains('500')) {
          errorMessage = 'Usuario inexistente';
        }
        switch (err.response.data) {
          case 'Usuario ya registrado':
            errorMessage = 'Este usuario ya ha sido registrado';
            break;
          case 'Token expiró':
            errorMessage =
              'El código asignado para validarse ya expiró y debe registrarse de nuevo';
            break;
          case 'Request failed with status code 400':
            errorMessage = 'Error en la petición';
            break;
          case 'Request failed with status code 401':
            errorMessage =
              'Error de autenticación, por favor vuelva a iniciar sesión';
            break;
        }
        err.response.data = errorMessage;
        reject(err);
        if (getters.isDebugMode) console.error(err);
      });
  });
}

export function postDatosPresupuesto ({ state, commit, getters, dispatch }) {
  let data = JSON.stringify({
    Tramos: state.Presupuesto.Tramos,
    DatosGenerales: {
      Nombre: state.Presupuesto.DatosGenerales.Nombre,
      ProvinciaId: state.Presupuesto.DatosGenerales.ProvinciaId,
      MunicipioId: state.Presupuesto.DatosGenerales.MunicipioId,
      Tecnologia: state.Presupuesto.DatosGenerales.Tecnologia,
      ServicioId: state.Presupuesto.DatosGenerales.ServicioId,
      ActuacionId: state.Presupuesto.DatosGenerales.ActuacionId,
      ProblemaId: state.Presupuesto.DatosGenerales.ProblemaId,
      NivelFreatico: state.Presupuesto.DatosGenerales.NivelFreatico,
      Trafico: state.Presupuesto.DatosGenerales.Trafico,
      MaterialId: state.Presupuesto.DatosGenerales.MaterialId,
      TerrenoId: state.Presupuesto.DatosGenerales.TerrenoId,
      PavimentoId: state.Presupuesto.DatosGenerales.PavimentoId,
      ProfundidadMedia: state.Presupuesto.DatosGenerales.ProfundidadMedia,
      Acometidas: state.Presupuesto.DatosGenerales.Acometidas,
      PozosRegistro: state.Presupuesto.DatosGenerales.PozosRegistro,
      Incidencias: state.Presupuesto.DatosGenerales.Incidencias,
      // Usuario: state.Presupuesto.DatosGenerales.Usuario,
      Email: state.Presupuesto.DatosGenerales.Email,
      Aplicacion: state.Presupuesto.DatosGenerales.Aplicacion,
      Id: 0
    }
  });
  // console.log('API_DATA: '  +  data);
  dispatch('putAxiosHeader');
  return new Promise((resolve, reject) => {
    Vue.axios({
      url: process.env.VUE_APP_API_TSZ_URL + '/Presupuestos',
      data: data,
      headers: { 'content-type': 'application/json' },
      method: 'POST'
    })
      .then(resp => {
        resolve(resp);
        // console.log('API_DATA: OK ' );
      })
      .catch(err => {
        var errorMessage = 'Error desconocido';
        // console.log('API_DATA: ERROR:' + err.message);
        switch (err.message) {
          case 'Network Error':
            errorMessage = 'Error de red';
            break;
          case 'Request failed with status code 400':
            errorMessage = 'Error en la petición';
            break;
          case 'Request failed with status code 401':
            errorMessage =
              'Error de autenticación, por favor vuelva a iniciar sesión';
            break;
        }

        reject(err);
        if (getters.isDebugMode) console.error(err);
      });
  });
}

export function getDatosTSZ ({ state, getters, dispatch }, argRequest) {
  let myRequest = { params: {} };

  myRequest = clone(argRequest);
  dispatch('putAxiosHeader');
  return new Promise((resolve, reject) => {
    Vue.axios({
      url: process.env.VUE_APP_API_TSZ_URL + '/' + myRequest.controller,
      params: myRequest.data,
      headers: [],
      method: 'GET'
    })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        var errorMessage = 'Error desconocido';

        switch (err.message) {
          case 'Network Error':
            errorMessage = 'Error de red';
            break;
          case 'Request failed with status code 400':
            errorMessage = 'Error en la petición';
            break;
          case 'Request failed with status code 401':
            errorMessage =
              'Error de autenticación, por favor vuelva a iniciar sesión';
            break;
        }
        reject(errorMessage);
        if (getters.isDebugMode) console.error(err);
      });
  });
}

export function getDatosTSZ_Listado_Comparativa (
  { state, getters, dispatch },
  argRequest
) {
  let myRequest = { params: {} };

  myRequest = clone(argRequest);
  dispatch('putAxiosHeader');
  return new Promise((resolve, reject) => {
    Vue.axios({
      url:
        process.env.VUE_APP_API_TSZ_URL +
        '/Aplicacion/' +
        process.env.VUE_APP_ID +
        myRequest.controller,
      params: myRequest.data,
      method: 'GET'
    })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        var errorMessage = 'Error desconocido';
        console.log('API_LISTADO: ' + err.response.data);
        switch (err.message) {
          case 'Network Error':
            errorMessage = 'Error de red';
            break;
          case 'Request failed with status code 400':
            errorMessage = 'Error en la petición';
            break;
          case 'Request failed with status code 401':
            errorMessage =
              'Error de autenticación, por favor vuelva a iniciar sesión';
            break;
        }
        reject(errorMessage);
        if (getters.isDebugMode) console.error(err);
      });
  });
}

export function getDatosTSZ_Listado_PDF (
  { state, getters, dispatch },
  argRequest
) {
  let myRequest = { params: {} };

  myRequest = clone(argRequest);
  dispatch('putAxiosHeader');
  return new Promise((resolve, reject) => {
    Vue.axios({
      url:
        process.env.VUE_APP_API_TSZ_URL +
        '/Aplicacion/' +
        process.env.VUE_APP_ID +
        myRequest.controller,
      params: myRequest.data,
      method: 'GET'
    })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        var errorMessage = 'Error desconocido';
        console.log('API_LISTADO: ' + err.response.data);
        switch (err.message) {
          case 'Network Error':
            errorMessage = 'Error de red';
            break;
          case 'Request failed with status code 400':
            errorMessage = 'Error en la petición';
            break;
          case 'Request failed with status code 401':
            errorMessage =
              'Error de autenticación, por favor vuelva a iniciar sesión';
            break;
        }
        reject(errorMessage);
        if (getters.isDebugMode) console.error(err);
      });
  });
}

export function comparativaOfertar ({ state, getters, dispatch }, argRequest) {
  let myRequest = { params: {} };

  myRequest = clone(argRequest);
  dispatch('putAxiosHeader');
  return new Promise((resolve, reject) => {
    Vue.axios({
      url:
        process.env.VUE_APP_API_TSZ_URL +
        '/Aplicacion/' +
        process.env.VUE_APP_ID +
        myRequest.controller,
      params: myRequest.data,
      data: myRequest.body,
      method: 'PUT'
    })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        var errorMessage = 'Error desconocido';
        console.log('API_LISTADO: ' + err.response.data);
        switch (err.message) {
          case 'Network Error':
            errorMessage = 'Error de red';
            break;
          case 'Request failed with status code 400':
            errorMessage = 'Error en la petición';
            break;
          case 'Request failed with status code 401':
            errorMessage =
              'Error de autenticación, por favor vuelva a iniciar sesión';
            break;
        }
        reject(errorMessage);
        if (getters.isDebugMode) console.error(err);
      });
  });
}

export function deletePresupuesto ({ state, getters, dispatch }, argRequest) {
  let myRequest = { params: {} };
  myRequest = clone(argRequest);

  dispatch('putAxiosHeader');
  return new Promise((resolve, reject) => {
    Vue.axios({
      url:
        process.env.VUE_APP_API_TSZ_URL +
        '/Aplicacion/' +
        process.env.VUE_APP_ID +
        myRequest.controller,
      method: 'DELETE'
    })
      .then(resp => {
        resolve(resp);
        console.log('API_DELETE_OK: ' + resp);
      })
      .catch(err => {
        var errorMessage = 'Error desconocido';
        console.log('API_DELETE: ' + err.response.data);
        switch (err.message) {
          case 'Network Error':
            errorMessage = 'Error de red';
            break;
          case 'Request failed with status code 400':
            errorMessage = 'Error en la petición';
            break;
          case 'Request failed with status code 401':
            errorMessage =
              'Error de autenticación, por favor vuelva a iniciar sesión';
            break;
        }
        reject(errorMessage);
        if (getters.isDebugMode) console.error(err);
      });
  });
}
export function getPasswordChangeRequest (
  { state, commit, getters, dispatch },
  argRequest
) {
  let myRequest = { params: {} };

  myRequest = clone(argRequest);
  return new Promise((resolve, reject) => {
    Vue.axios({
      url:
        process.env.VUE_APP_API_URL + '/AnonymousUser' + myRequest.controller,
      params: myRequest.data,
      headers: { 'content-type': 'application/json' },
      method: 'GET'
    })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        var errorMessage = 'Se ha producido un error.';
        switch (err.response.data) {
          case 'Usuario no registrado':
            errorMessage =
              'Este usuario no ha sido registrado en Tecnologías sin zanja';
            break;
        }
        err.response.data = errorMessage;
        reject(err);
        if (getters.isDebugMode) console.error(err);
      });
  });
}

export function putPassword ({ state, commit, getters, dispatch }, argRequest) {
  let myRequest = { params: {} };

  myRequest = clone(argRequest);
  let data = JSON.stringify({
    data: {
      mail: myRequest.data.mail,
      token: myRequest.data.token,
      password: myRequest.data.password
    }
  });
  return new Promise((resolve, reject) => {
    Vue.axios({
      url:
        process.env.VUE_APP_API_URL + '/AnonymousUser' + myRequest.controller,
      data: data,
      headers: { 'content-type': 'application/json' },
      method: 'PUT'
    })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        var errorMessage = 'Se ha producido un error.';
        switch (err.response.data) {
          case 'Token incorrecto':
            errorMessage = 'El token que se envió ha expirado.';
            break;
        }
        err.response.data = errorMessage;
        reject(err);
        if (getters.isDebugMode) console.error(err);
      });
  });
}
